import { render, staticRenderFns } from "./organizaties.vue?vue&type=template&id=01934f7e&"
import script from "./organizaties.vue?vue&type=script&lang=js&"
export * from "./organizaties.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports